module.exports = __webpack_public_path__ + "static/media/pengumuman.3661b7aa.png";